import { Container, Typography } from "@mui/material";

import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";
import { Plans, ShopDevices } from "@/components/Subscription";
import Section from "@/components/Section";

const SubscriptionPlans = () => {
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, lg: 0 } }}>
        <BreadcrumbsNav />
      </Container>
      <Section pt={{ xs: 0, md: 2, lg: 8 }} pb={{ xs: 5, md: 6, lg: 8 }}>
        <Typography
          color="text.primary"
          variant="h1"
          mb={{ xs: 2, md: 3 }}
          sx={{ textAlign: { xs: "start", md: "center" } }}
        >
          Explore Our Subscription Tiers 
        </Typography>
        <Typography
          variant="subtitle1"
          component="p"
          color="text.secondary"
          sx={{ textAlign: { xs: "start", md: "center" } }}
        >
          We offer comprehensive and affordable packages to suit all of your needs. 
        </Typography>
        <ShopDevices />
      </Section>
      <Plans />
    </>
  );
};

export default SubscriptionPlans;
